import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

// TODO: remove inline styles
const styles = {
    padding: '45px 0',
    textAlign: 'center',
};

export default function ButtonContainer(props) {
    return (
        <div style={styles}>
            {props.children}
        </div>
    );
}

ButtonContainer.displayName = displayName('Dialog/ButtonContainer');

ButtonContainer.propTypes = {
    children: PropTypes.any.isRequired,
};
